export function getAddToCardEventPayload(
  contentID: string,
  contentType: string,
): { content_id: string; content_type: string } {
  return {
    content_id: contentID,
    content_type: contentType,
  };
}
